import React, { Component, Fragment } from 'react';
import Media from 'react-media';
import FilterCheckbox from './filterCheckbox';
import FilterSlider from './filterSlider';
import FilterSearch from './filterSearch';
import { PriceHiderContainer } from './style';
import { ConnectedPriceHider } from '../../containers/ui';
import { ActionButton } from '../buttons';

import { filterSortingStrategy as sort } from '../../util';

class FilterCheckboxes extends Component {
  attributes = [
    {
      attribute: 'brand',
      label: 'Marke',
      operator: 'or',
      transformItems: sort,
    },
    {
      attribute: 'segment.de',
      label: 'Segment',
      operator: 'or',
      transformItems: sort,
    },
    {
      attribute: 'material.category.de',
      label: 'Material',
      operator: 'or',
      transformItems: sort,
    },
    {
      attribute: 'color.category.de',
      label: 'Farbe',
      operator: 'or',
      transformItems: sort,
    },
    {
      attribute: 'frameType.de',
      label: 'Fassungsart',
      operator: 'or',
      transformItems: sort,
    },
    {
      attribute: 'shapeForm.de',
      label: 'Fassungsform',
      operator: 'or',
      transformItems: sort,
    },
  ];
  state = { activeSection: '' };

  toggleSection = attribute => {
    const { activeSection } = this.state;
    if (attribute === activeSection) this.setState({ activeSection: '' });
    else this.setState({ activeSection: attribute });
  };

  render() {
    const { activeSection } = this.state;
    return (
      <Fragment>
        {this.attributes.map(a => (
          <FilterCheckbox
            {...a}
            key={a.attribute}
            sectionIsOpen={activeSection === a.attribute}
            toggle={this.toggleSection}
          />
        ))}
      </Fragment>
    );
  }
}

class FilterWidgets extends Component {
  render() {
    const { hasHits, onFilterReset } = this.props;
    return (
      <Fragment>
        <FilterSearch />
        <Fragment>
          <ConnectedPriceHider hasHits={hasHits}>
            {({ showPrices }) => {
              return (
                <PriceHiderContainer showPrices={showPrices} hasHits={hasHits}>
                  <FilterSlider
                    attribute="prices.default"
                    label="Preis"
                    unit="€"
                    hide={!showPrices}
                  />
                  <FilterCheckboxes />
                  <FilterSlider
                    attribute="bridgeWidth"
                    label="Stegweite"
                    unit="mm"
                  />
                  <FilterSlider
                    attribute="lensWidth"
                    label="Scheibengröße"
                    unit="mm"
                  />
                  <Media query="(min-width: 52em)">
                    {matches =>
                      matches ? (
                        <ActionButton onClick={onFilterReset}>
                          Suche zurücksetzen
                        </ActionButton>
                      ) : (
                        <div />
                      )
                    }
                  </Media>
                </PriceHiderContainer>
              );
            }}
          </ConnectedPriceHider>
        </Fragment>
      </Fragment>
    );
  }
}

export default FilterWidgets;



// WEBPACK FOOTER //
// ./src/components/filter/filterWidgets.js